(function (window, document, cookieConsentName, dataLayerName) {
  window[cookieConsentName] = window[cookieConsentName] || {};
  window[dataLayerName] = window[dataLayerName] || [];
  const dialog = document.getElementById('cookie-consent-settings');
  let dispose;

  function hide() {
    if (dispose) {
      dispose();
      dispose = undefined;
    }

    dialog.hidden = true;
  }

  function show() {
    const cookieConsent = window[cookieConsentName].consent;
    const form = document.getElementById('cookie-consent-settings-form');
    const closeButton = document.getElementById('cookie-consent-settings-close');
    const allButton = document.getElementById('cookie-consent-settings-all');
    const cookiePolicyLink = document.getElementById('cookie-consent-settings-cookie-policy');
    const { options } = cookieConsent;
    const currConsent = cookieConsent.get() || { necessary: true };

    const init = (consent) => {
      for (const i in options) {
        const input = form.querySelector(`input[name=${options[i]}]`);

        if (input) {
          input.checked = consent[options[i]];
        }
      }
    };

    const handleAll = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.settings`,
        cookieSettingsAction: 'click',
        cookieSettingsLabel: 'Accept All',
      });

      const nextConsent = {};

      for (const i in options) {
        nextConsent[options[i]] = true;
      }

      cookieConsent.set(nextConsent);
      hide();
    };

    const handleSubmit = (event) => {
      event.preventDefault();

      const data = new FormData(event.target);
      const nextConsent = {};

      for (const i in options) {
        nextConsent[options[i]] = data.get(options[i]) === 'on';
      }

      window[dataLayerName].push({
        event: `${cookieConsentName}.settings`,
        cookieSettingsAction: 'submit',
        cookieSettingsLabel: getSubmitLabel(nextConsent),
      });

      cookieConsent.set(nextConsent);
      hide();
    };

    const handleFormClick = ({ target: { type, name, checked } }) => {
      if (type === 'checkbox') {
        window[dataLayerName].push({
          event: `${cookieConsentName}.settings`,
          cookieSettingsAction: checked ? 'check' : 'uncheck',
          cookieSettingsLabel: getCheckboxLabel(name),
        });
      }
    };

    const handleClose = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.settings`,
        cookieSettingsAction: 'click',
        cookieSettingsLabel: 'close',
      });

      hide();
    };

    const handleCookiePolicy = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.settings`,
        cookieSettingsAction: 'click',
        cookieSettingsLabel: 'Cookie policy',
      });
    };

    form.addEventListener('submit', handleSubmit);
    form.addEventListener('click', handleFormClick);
    closeButton.addEventListener('click', handleClose);
    allButton.addEventListener('click', handleAll);
    cookiePolicyLink.addEventListener('click', handleCookiePolicy);

    dispose = () => {
      form.removeEventListener('submit', handleSubmit);
      form.removeEventListener('click', handleFormClick);
      closeButton.removeEventListener('click', handleClose);
      allButton.removeEventListener('click', handleAll);
      cookiePolicyLink.removeEventListener('click', handleCookiePolicy);
    };

    init(currConsent);

    dialog.hidden = false;
  }

  function getCheckboxLabel(name) {
    switch (name) {
      case 'analytics': return 'Analytical cookies';
      case 'functional': return 'Functional cookies';
      case 'targeting': return 'Targeting cookies';
      default: return undefined;
    }
  }

  function getSubmitLabel({ analytics, functional, targeting }) {
    return [
      'necessary',
      analytics && 'analytical',
      functional && 'functional',
      targeting && 'targeting',
    ].filter(Boolean).join('-');
  }

  window[cookieConsentName].settings = { show, hide };
}(window, document, 'cookieConsent', 'dataLayer'));
